<template>
  <div>
    <el-dialog class="rz_detail" :visible.sync="newouterVisible" title="认证详情" append-to-body>
      <div class="left_block">
        <div class="block">
          <div class="lefts">企业类型</div>
          <span class="rights">企业</span>
        </div>
        <div class="block">
          <div class="lefts">证件类型</div>
          <span class="rights">多证合一营业执照</span>
        </div>
        <div class="block">
          <div class="lefts">营业执照</div>
          <div class="comfirm_icon">
            <img :src="src_msg" @click="show_pic_fun" />
          </div>
        </div>
        <div class="block">
          <div class="lefts">统一社会信用代码</div>
          <span class="rights">123456789987654321</span>
        </div>
        <div class="block">
          <div class="lefts">企业名称</div>
          <span class="rights">多证合一营业执照科技有限公司</span>
        </div>
        <div class="block">
          <div class="lefts">法人代表</div>
          <span class="rights">某某某</span>
        </div>
        <div class="block">
          <div class="lefts">法人代表身份证号</div>
          <span class="rights">123456789987654321</span>
        </div>
        <div class="block">
          <div class="lefts">所在城市</div>
          <span class="rights">某某某</span>
        </div>
        <div class="block">
          <div class="lefts">详细地址</div>
          <span class="rights">123456789987654321</span>
        </div>
      </div>
      <div class="right_block">
        <div class="block">
          <div class="lefts">申请人名称</div>
          <span class="rights">马某某</span>
        </div>
        <div class="block">
          <div class="lefts">申请人手机号</div>
          <span class="rights">18866668888</span>
        </div>
        <div class="block">
          <div class="lefts">申请人身份证号</div>
          <span class="rights">123456789987654321</span>
        </div>
        <div class="checking"></div>
        <div class="checked">
          <div class="checked_fail" v-show="failed==0">
            <div class="block">
              <div class="lefts">认证状态</div>
              <span class="rights">认证失败</span>
            </div>
            <div class="block">
              <div class="lefts">驳回理由</div>
              <span class="rights">2019-12-31 18：00：00</span>
            </div>
          </div>
          <div class="checked_success" v-show="failed==1">
            <div class="block">
              <div class="lefts">认证状态</div>
              <span class="rights">认证成功</span>
            </div>
          </div>
          <div class="block">
            <div class="lefts">审核人</div>
            <span class="rights">王审核</span>
          </div>
          <div class="block">
            <div class="lefts">审核时间</div>
            <span class="rights">2019-12-31 18：00：00</span>
          </div>
          <div class="checked_success" v-show="failed==2">
            <div class="block newblock">
              <div class="one pop" @click="failed_check">驳回申请</div>
              <div class="two pop" @click="success_check">认证成功</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <showPic ref="showPic"></showPic>
  </div>
</template>
<script>
export default {
  components: {
    showPic: () =>
      import(/* webpackChunkName: "design" */ "../../../components/show_pic")
  },
  data() {
    return {
      src_msg:require('@/assets/1.jpg'),
      failed: 2, //0；认证失败 1；认证成功 2；待审核 其他：组织信息页面查询详情
      newouterVisible: false,
      org_name: "加优科技有限公司",
      org_func: "担当审批",
      detail_obj: {}
    };
  },
  methods: {
    //图片预览
    show_pic_fun(src_msg) {
      let img = this.src_msg
      this.$refs.showPic.init(img);
    },
    //认证成功
    success_check() {
      this.$confirm("", "是否通过该组织的认证申请", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        center: true
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "认证成功!"
          });
          this.newouterVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "认证失败"
          });
        });
    },
    //驳回认证申请
    failed_check() {
      this.$prompt("", "提示", {
        confirmButtonText: "确认驳回",
        cancelButtonText: "取消",
        showCancelButton: false
      })
        .then(({ value }) => {
          this.$message({
            type: "info",
            message: "已驳回申请：" + value
          });
          this.newouterVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    init(a) {
      this.newouterVisible = true;
      this.failed = a;
    }
  }
};
</script>
<style lang="scss" scoped>
.rz_detail {
  /deep/.el-dialog {
    width: 800px;

    /deep/.el-dialog__header {
      text-align: left !important;
      padding: 12px 18px;
      border-bottom: 1px solid #f4f4f4;
      .el-dialog__title {
        font-size: 16px;
        color: #323232;
        font-weight: 400;
      }
    }
    /deep/.el-dialog__body {
      padding: 0px 50px 30px 50px;
      width: auto;
      display: flex;
      position: relative;
      .left_block {
        flex: 1;
        border-right: 1px solid #f4f4f4;
      }
      .right_block {
        flex: 1;
        padding-left: 30px;
      }
      .newblock {
        position: absolute;
        bottom: 50px;
        right: 50px;
        .pop {
          margin-right: 10px;
          padding: 8px 15px;
          border-radius: 5px;
          cursor: pointer;
          margin-right: 20px;
        }
        .one {
          color: #fff;
          background-color: red;
        }
        .two {
          color: #fff;
          background-color: #2479ed;
        }
      }
      .block {
        display: flex !important;
        margin-top: 20px;
        .lefts {
          font-size: 16px;
          width: 130px;
          flex-shrink: 0;
          font-weight: bold;
          color: #323232;
          text-align: right;
          margin-right: 20px;
        }
        .rights {
          font-size: 14px;
          flex: 1;
          text-align: left;
          line-height: 24px;
        }
        .comfirm_icon {
          width: 80px;
          height: 100px;
          img {
            width: 80px;
            height: 100px;
          }
        }
      }
    }
  }
}
</style>